/*
 * Copyright (c) 2025 Frayo and HomeChef360. All Rights Reserved.
 *
 * CONFIDENTIAL & PROPRIETARY
 * This software and its source code are the confidential and proprietary
 * information of Frayo and HomeChef360. Unauthorized copying, modification,
 * distribution, disclosure, or use of this code, in whole or in part, via any
 * medium, is strictly prohibited without prior written consent.
 *
 * Violations will be subject to legal action in the State of Florida and may
 * also be pursued under applicable U.S. federal law.
 */

import { useNavigate } from "react-router-dom";

const ProfilePicSuccess = () => {
  const navigate = useNavigate();
  return (
    <section className="container-fluid">
      <div className="overlay"></div>
      <div className="drawer small">
        <div className="alert-wrap">
          <img
            className="ico mb-4"
            src="/assets/images/alert-success-ico.svg"
            alt="success"
          />
          <h1 className="mb-4">Awesome!</h1>
          <p className="mid-gray mb-2">
            <small>Your profile updated successfully</small>
          </p>
          <h6 className="medium mb-4"></h6>

          <button
            className="btn btn-cancel rounded-5"
            onClick={() => navigate("/settings")}
          >
            Back to Home
          </button>
        </div>
      </div>
    </section>
  );
};
export default ProfilePicSuccess;
